window.M = window.M || {};

M.MiniProfiler = {
    render: function(cb) { 
        $.get("/api/User/Current/Profiler", function(data) {
            var html = M.templates.miniprofile({
                ids: data.join(","),
                user: M.CurrentUser
            });
            
            //var frag = $.parseHTML(html);
            
            $(document.body).append(html);
            cb();
        });
    }
};